import outsideClick from './outsideClick';
import {slideUp, slideDown, slideToggle} from "./slide";
export default class SearchForm{
    constructor(selector){
        this.form = document.querySelector('.header-desktop .search-form');
        if (this.form){
            this.submit = this.form.querySelector('.search-submit');
            this.desktopSearchForm();
        }

        this.mobileToggle = document.querySelector('.header-mobile .search-toggle');
        this.mobileSearchForm = document.querySelector('.header-mobile .search-form');
        this.toggling = false;


        this.headerMobile = document.querySelector('.header-mobile');
        this.headerMobileContent = this.headerMobile.querySelector('.header__content');

        if (this.mobileToggle && this.mobileSearchForm){
            this.mobileSearchFormHandle();
        }
    }

    mobileSearchFormHandle(){
        this.mobileToggle.addEventListener('click', () => {
            if (!this.toggling){
                this.toggling = true;
                this.mobileToggle.classList.toggle('active');
                this.mobileSearchForm.classList.toggle('active');
                slideToggle(this.mobileSearchForm, 500, () => { this.toggling = false });

                if (this.headerMobile.classList.contains('active')){   
                    this.headerMobile.classList.toggle('active');
                    document.body.classList.toggle('menu-opened');
                    slideToggle(this.headerMobileContent, 500);
                }
            }
        });
    }

    desktopSearchForm(){
        this.submit.addEventListener('click', (e)=>{
            console.log('e');
            if (!this.form.classList.contains('active')){
                e.preventDefault();
                this.form.classList.add('active');
            }
        })

        window.addEventListener('click', (e) => {
            if (outsideClick(e, this.form) && this.form.classList.contains('active')) {
                this.form.classList.remove('active');
            }
         });
    }
}